const pad = (n: number | string) => n.toString().padStart(2, '0');

export const formatTime = (input: number | string): string => {
  const i = input.toString();

  if (i.includes(':')) {
    const [m, s] = i.split(':');
    const minutes = isNaN(parseInt(m)) ? 0 : parseInt(m);
    const seconds = isNaN(parseInt(s)) ? 0 : Math.min(59, parseInt(s));
    return `${pad(minutes)}:${pad(seconds)}`;
  }

  if (isNaN(parseInt(i))) return '00:00';

  const totalSeconds = parseInt(i.replace(/\D/g, '') || '1', 10);
  if (totalSeconds === 0) return '00:00';
  return `${pad(Math.floor(totalSeconds / 60))}:${pad(totalSeconds % 60)}`;
};

export const parseTime = (input: string): number => {
  if (!String(input).includes(':')) {
    if (isNaN(parseInt(String(input)))) return 0;
    return parseInt(String(input), 10);
  }
  const [minutes, seconds] = String(input).split(':');
  if (!minutes) return isNaN(parseInt(seconds)) ? 0 : parseInt(seconds, 10);
  return isNaN(parseInt(minutes))
    ? 0
    : parseInt(minutes, 10) * 60 +
        Math.min(59, isNaN(parseInt(seconds)) ? 0 : parseInt(seconds, 10));
};

type ClampedTime = {
  input: string | number;
  min: number;
  max: number;
};

const clampTime = (p: ClampedTime): number => {
  return Math.min(Math.max(parseInt(p.input.toString(), 10), p.min), p.max);
};

export const parseTimeClamped = (p: ClampedTime): number =>
  clampTime({ input: parseTime(String(p.input)), min: p.min, max: p.max });

export const formatTimeClamped = (p: ClampedTime): string =>
  formatTime(parseTimeClamped(p));
